import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class DeleteUserFavoriteUseCase extends UseCase {
  constructor({repository, getCurrentUserService}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'DeleteUserFavoriteUseCase#execute'})
  @inlineError
  async execute({adId}) {
    try {
      const userEntity = await this._getCurrentUserService.execute()
      const userId = userEntity.getId()

      return this._repository.delete({
        adId,
        userId
      })
    } catch (e) {
      throw this._userNotLoggedInError('[DeleteUserFavoriteUseCase#execute] User is not logged in')
    }
  }
}

export default DeleteUserFavoriteUseCase
